"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateCheckCodeRequest = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsDynamicCode_1 = require("../../model/hsDynamicCode");
var service_1 = require("../../../library/base/service");
var ValidateCheckCodeRequest = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ValidateCheckCodeRequest, _super);
    function ValidateCheckCodeRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '恒生验证码验证接口';
        _this.code = '105031';
        _this.desc = '恒生验证码验证接口';
        _this.requestParams = new hsDynamicCode_1.ValidateCheckCodeRequestRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ValidateCheckCodeRequest;
}(service_1.BaseService));
exports.ValidateCheckCodeRequest = ValidateCheckCodeRequest;
//# sourceMappingURL=validateCheckCodeRequest.js.map